module.exports = __webpack_public_path__ + "static/img/r1.8488035.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sp/r1.png
// module id = hnnz
// module chunks = 0